import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import relativeTime from 'dayjs/plugin/relativeTime';

// Global config: imported once from main.tsx, so every `dayjs()` is French.
dayjs.extend(relativeTime);
dayjs.locale('fr');
